/* Display estimates only: never changes cart prices or applies discounts. */
if (!customElements.get('saam-offer-prices')) {
  customElements.define('saam-offer-prices', class extends HTMLElement {
    connectedCallback() {
      this.formatter = new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: this.dataset.currency || 'INR',
        minimumFractionDigits: 0, maximumFractionDigits: 0,
      });
      this.renderPrice(Number(this.dataset.price));
      this.unsubscribe?.();
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== this.closest('product-info')?.dataset.section) return;
        this.renderPrice(data.variant?.price);
      });
    }

    disconnectedCallback() { this.unsubscribe?.(); }

    renderPrice(price) {
      const valid = Number.isFinite(price) && price >= 0;
      this.querySelectorAll('[data-offer-percent]').forEach((line) => {
        line.hidden = !valid;
        if (!valid) return;
        const percent = Number(line.dataset.offerPercent);
        const amount = this.formatter.format(Math.round(price * (100 - percent) / 10000));
        const current = this.formatter.format(Math.round(price / 100));
        const originalPrice = document.createElement('s');
        originalPrice.textContent = current;
        originalPrice.setAttribute('aria-label', `Current selling price ${current}`);
        const offerPrice = document.createElement('span');
        offerPrice.textContent = amount;
        offerPrice.setAttribute('aria-label', `Estimated offer price ${amount}`);
        line.replaceChildren(originalPrice, document.createTextNode(' '), offerPrice);
        if (percent !== 10) line.append(document.createTextNode(' when eligible'));
      });
    }
  });
}
